import React from "react";
import { Location } from "../Location";
import ContractViewer from "../../contractViewer/ContractViewer";

interface Params {
  contractId: string;
  contractName?: string;
}

export class ContractViewLocation extends Location<Params> {
  constructor(contractId: string, contractName?: string) {
    super({ contractId, contractName });
  }

  render(): React.ReactElement<any> {
    return (
      <ContractViewer
        id={this.params.contractId}
        contractName={this.params.contractName}
      />
    );
  }

  toURI() {
    const { contractId } = this.params;
    return `/contract/${contractId} `;
  }
}
